import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { InvoiceProjectByStatus, loaders, invoiceControlConfigByCode } from 'entities';

import { Button } from 'components/Blocks';

import { truncateText } from 'utils/text';

import { UserOwnershipBreakdown } from '../components';

import { resolveColorClass } from 'styles';

export function TeamProjects() {
  const { t } = useLang();

  const controlsByUser = loaders.invoice.invoiceControlByUsers.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'INVOICE_CONTROL_ASSIGNMENT',

      onMessage: (assigned, controls = {}) => {
        const existsHere = !!controls[assigned.owner.id]?.controls?.find?.(
          ({ project }) => project.id === assigned.project.id,
        );

        return existsHere
          ? controls
          : {
              ...controls,

              [assigned.owner.id]: {
                ...controls[assigned.owner.id],

                total: (controls[assigned.owner.id].total ?? 0) + 1,

                controls: [
                  ...controls[assigned.owner.id].controls,
                  assigned as unknown as InvoiceProjectByStatus,
                ],
              },
            };
      },
    },
  });

  const entries = useMemo(() => {
    return Object.values(controlsByUser.data)
      .map((x) => x.controls.map((control) => ({ ...control, id: control.project.id })))
      .flat();
  }, [controlsByUser.data]);

  return (
    <UserOwnershipBreakdown
      title={t('active-projects-per-user')!}
      statusConfig={invoiceControlConfigByCode}
      loading={controlsByUser.loading}
      entries={entries}
      totalResolver={(userId) => controlsByUser.data[userId]?.total ?? 0}
      render={({ project, status }) => (
        <Button
          tooltipContent={project.name}
          variant="ghost"
          to="projectProfile"
          params={{ projectId: project.id }}
          linkTarget={project.id}
          className={resolveColorClass(invoiceControlConfigByCode[status].color, 'text')}
        >
          {truncateText(project.name, 35)}
        </Button>
      )}
    />
  );
}
